import { FC } from 'react';
import TextField from 'components/forms/textField/TextField';
import { useTranslation } from 'react-i18next';

const MessageNameField: FC = () => {
  const { t } = useTranslation();

  return (
    <TextField
      label={t('pageAutomations.scheduledMessages.filters.messageName')}
      name="messageName"
      colSmInput={8}
      colSmLabel={4}
    />
  );
};

export default MessageNameField;
